import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const styles = {
  loadingItem: cn("h-16", shared.skeleton),
  emptyIcon: "mb-4 h-14 w-14 text-muted-foreground/40",
  emptyText: "text-lg font-medium text-foreground",
  emptyHint: "mt-1 text-sm text-muted-foreground max-w-sm",
  emptyAction:
    "mt-4 inline-flex items-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors active:scale-[0.98]",
  card: "group rounded-xl bg-card text-card-foreground shadow-card border border-border transition-all duration-200 hover:border-primary/25 overflow-hidden relative",
  cardHeader: cn(shared.rowBetween, "gap-3 p-4 cursor-pointer select-none transition-colors duration-150 hover:bg-accent/60"),
  cardHeaderContent: "flex flex-col items-start gap-0.5",
  cardTitle: cn(shared.rowGap2, "font-semibold text-foreground"),
  iconButtonDanger:
    "inline-flex items-center justify-center rounded-lg p-2 text-muted-foreground hover:bg-destructive/10 hover:text-destructive transition-all duration-150 active:scale-95",
  expandLabel: "flex items-center justify-center text-muted-foreground",
  expandedSection: "border-t pt-4 mt-4 border-border px-3 pb-4 sm:px-4",
  providerList: "mt-4 space-y-2.5 sm:space-y-2",
  assignButton:
    "inline-flex items-center gap-1.5 rounded-lg border border-dashed border-border px-3 py-2 text-sm font-medium text-muted-foreground hover:border-primary/50 hover:text-primary hover:bg-primary/5 transition-all duration-150 active:scale-[0.98]",
  providerItem: cn(shared.rowBetween, "gap-3 rounded-lg bg-secondary/40 px-3 py-3 transition-all duration-150 hover:bg-secondary/70 sm:py-2.5"),
  providerActions: "flex items-center gap-1",
  providerName: cn(shared.rowGap2, shared.titleSm),
  dialogHeader: cn(shared.rowGap3, "border-b border-border px-6 py-4"),
  dialogIcon: cn(shared.iconMd, shared.iconPrimary),
  dialogBody: "px-6 py-4 space-y-4",
  formLabel: "text-sm font-medium text-foreground/80",
  buttonGroup: "mt-6 flex gap-3",
  primaryButton: cn(shared.primaryButton, "flex-1 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed"),
  secondaryButton: cn(shared.secondaryButton, "flex-1 disabled:cursor-not-allowed"),
  checkboxLabel: cn(shared.rowGap2, "text-sm text-muted-foreground cursor-pointer hover:text-foreground transition-colors"),
  passwordHint: cn(shared.mutedXs, "mt-1"),
  passwordField: "space-y-1",
  providerCard: "rounded-lg border bg-card px-3 py-2.5 transition-all duration-150 hover:shadow-sm hover:border-border/80",
  cardTitleIcon: cn(shared.iconSm, shared.iconPrimary),
  errorIcon: cn(shared.iconSm, "shrink-0"),
  iconH4W4Transition: cn(shared.iconSm, "transition-transform duration-200"),
};

export { styles };
